/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_C21Inputs */

const en_job_form_enum_c21 = /** @type {(inputs: Job_Form_Enum_C21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C2 - Proficient`)
};

const de_job_form_enum_c21 = /** @type {(inputs: Job_Form_Enum_C21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C2 - Annähernd muttersprachliche Kenntnisse`)
};

/**
* | output |
* | --- |
* | "C2 - Proficient" |
*
* @param {Job_Form_Enum_C21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_c21 = /** @type {((inputs?: Job_Form_Enum_C21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_C21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_c21(inputs)
	return en_job_form_enum_c21(inputs)
});
export { job_form_enum_c21 as "job_form_enum_C2" }